import {data} from './data';

export const references = {
	title: 'Referencie',

	showMore: 'Zobraziť viac',
	showLess: 'Zobraziť menej',

	country: 'Krajina',
	location: 'Lokácia',
	completion: 'Dokončenie',
	investor: 'Investor',
	architect: 'Generálny Projektant',
	author: 'Autor Návrhu',

	data,
};
